<template>
  <div class="container">
    <div class="content-area header" ref="header">
    	<div class="title">
			{{work.name}}
    	</div>
     	<div class="note">
			<span><i>年级：</i>{{convertGrade(work.gid)}}</span>
			
        <!--
			<span><i>指导老师：</i>{{work.teacher}}</span>
        -->
    	</div>
    </div>
    <div class="top" v-show="topShow">
      <div class="top-left">
	  	<div>{{work.name}}</div>
		<div>
			<span><i>年级：</i>{{convertGrade(work.gid)}}</span>
			
        <!--
			<span><i>指导老师：</i>{{work.teacher}}</span>
        -->
      	</div>
      </div>
      <div style="flex: 1"></div>
      <div class="top-right">
			<span class="button primary-btn" @click="deleteWork" > 删除当前作品</span>
			<span class="button primary-btn" @click="updateWork"> 修改当前作品</span>
      </div>
    </div>
    <div class="content-area">
    <!--
   		<div class="label">指导老师点评：</div>
     	<div class="">
			<p>{{work.teacher_comment}}</p>
    	</div>
    -->
   		<div class="label">作品设计说明：</div>
	    <div class="">
			<p>{{work.note}}</p>
    	</div> 
<!--
   		<div class="label">作品设计说明已上传文件：</div>
	    <div class="" style="text-align:left;">
			<a style="color:black;font-size:14px;" :href="url+'/assets/upload/'+work.design_file">已上传文件（点击可下载）</a>
    	</div> 
-->
   		<div class="label">作品功能内容分类：<span class="value">{{work.audience}}</span></div>
   		<div class="label">作品地形环境分类：<span class="value">{{work.env}}</span></div>
   		<div class="label">作品针对面积分类：<span class="value">{{work.area}}</span></div>
   		<div class="label" v-if="work.spec != ''">作品任务书：</div>
   	    <div class="work-img" v-if="work.spec != ''">
          <img :src="url +'/assets/upload/'+ work.spec"></img>
        </div>
        <template v-if="work.imgs_url.split(':').length > 0">
    	    <div class="label">作品图纸图片：</div>
            <div class="work-img" v-for="(imgSrc, index) in work.imgs_url.split(':')[0].split(';')" :key="index">
              <img :src="url +'/assets/upload/'+ imgSrc"></img>
            </div>
        </template>
        <template v-if="work.imgs_url.split(':').length > 1">
     	    <div class="label">作品实体模型照片：</div>
            <div class="work-img" v-for="(imgSrc, index) in work.imgs_url.split(':')[1].split(';')" :key="index">
              <img :src="url +'/assets/upload/'+ imgSrc"></img>
            </div>
        </template>
    	<div class="label" v-if="work.videos_url != ''">作品视频：</div>
        <div class="work-video" v-if="work.videos_url != ''">
        	<div class="zhezhao">
        	</div>
        	<video controls>
                <source :src="url +'/assets/upload/'+ work.videos_url" type="video/mp4">
                当前浏览器不支持该视频格式
         	</video>
        </div>
        <div class="btn-section">
		    <span class="button primary-btn" @click="deleteWork" > 删除当前作品</span>
		    <span class="button primary-btn" @click="updateWork"> 修改当前作品</span>
        </div>
	</div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  inject: ['reload'],
  data () {
    return {
      token: '',
      url: this.API,
      topShow: false,
      wid: '',
      work: {}
    }
  },
  components: {
  },
  created () {
    let _t = this;
    _t.wid = _t.$route.params.id
    _t._getData()
  },
  computed: {
   
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll(){
      const sTop = document.documentElement.scrollTop
      const top = this.$refs.header.offsetTop
      if (sTop > top) {
        this.topShow = true
      }else{
        this.topShow = false
      }
    },
    _getData: function () {
      let _t = this
      _t.token = _t.$ls.get('token')
      console.log('post request', _t.API)
      axios.post(_t.API + '/api/work/detail/', {token: _t.token, wid: _t.wid})
        .then(function (resp) {
          if (resp.data.code == '0') {
             _t.work = resp.data.data
          } else {
             _t.$messagewarning(resp.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    deleteWork: function () {
      let _t = this
      _t.token = _t.$ls.get('token')
      _t.$confirm('此操作将永久删除该作品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
       axios.post(_t.API + '/api/work/mydelete/', {token: _t.token, id: _t.wid})
        .then(function (resp) {
          if (resp.data.code == '0') {
              _t.$messagesuccess('作品删除成功！')
              _t.$router.push(/work/)
          } else {
              _t.$messagewarning(resp.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      }).catch(() => {
        _t.$messagewarning('已取消删除')
      });
    },
    updateWork: function () {
        let _t = this
        _t.$router.push(`/workdetailupdate/${_t.wid}`)
    },
    convertGrade (val) {
      let grades = ['一年级', '二年级', '三年级', '赛道二']
      return grades[parseInt(val) - 1];
    }
  }
}
</script>
<style scoped lang='stylus'>
@import '~@/common/stylus/index'

.clearfix:after{
  content:"";
  clear:both;
}
.clearfix{
  *zoom: 1;
}
.container{
    text-align: center;
}
.title{
    font-family: sybold;
    font-size: 20px;
    color:black;
}
.note{
    margin-top:10px;
}
.note >span{
    margin-right:20px;
}
.note span i{
  color $color-light-gray
}
p{
    font-family: sylight;
    color:black;
    font-size: 17px;
    text-align: justify;
    line-height: 1.8em;
    margin-top:30px;
    text-indent: 2em;
    white-space: pre-line;
}
.banner{
    height: 120px;
    padding: 10px calc((100% - 1024px) / 2);
    position: relative;
}
.banner >img{
    height: 100%;
    width: 100%;
    position: relative;
}
.top{
  width: 100%
  padding: 0 calc((100% - 1024px) / 2);
  position: fixed
  top:0
  left:0
  background: black 
  text-align left
  display: flex
  flex-direction: space-between
  z-index: 1000
  height: 80px 
  .top-left{
    margin-left: 20px
    justify-content: flex-start
    div{
      margin: 10px 0
      font-size 14px
      line-height 14px
      height 14px
      color $color-light-gray
      span {
        margin-right: 10px
      }
    }
  }
  .top-right{
    padding: 20px 0
    display: flex
  }
}
.content-area{
    padding: 0 calc((100% - 1024px) / 2);
    margin-top: 30px;
}
.content-area p{
  font-size 14px
}
.label{
  margin 30px 0 0 0
  font-size 14px
  line-height 24px
  color $color-light-gray
  text-align left
}
.value{
  color: #000;
}
.work-img{
  margin 20px 0 0 0
}
.work-video{
  width: 1024px;
  height: 400px;
  position: relative;
  background: url(../assets/img/banner.jpg);
  margin-top: 20px;
}
.zhezhao{
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0.5;
}
.work-video video{
  max-width: 1024px !important;
  height: 100%;
  margin: 30px calc((100% - 600px) / 2);
  background: gray;
  margin: 0 auto;
  position: relative;
  top: -400px;
  border-radius:4px;
}
.btn-section{
  text-align center
  margin 30px 0 0 0
}
.primary-btn{
  display inline-block
}

</style>



// WEBPACK FOOTER //
// WorkDetail.vue?04a8a9be